var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"cart-not-compatible-info"},[_vm._v("\n    W koszyku znajdują się niekompatybilne opcje dostaw produktów uniemożliwiające złożenie zamówienia.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }